import { ref } from 'vue'

interface ExamContent {
  no: number
  subNo: number
  component: string
}

interface ExamData {
  examId: number
  name: string
  contents: ExamContent[]
}

const examData = ref<ExamData | null>(null)
const examCompleted = ref<boolean>(false)

// Storage for individual exam component data
const examComponentData = ref<Record<string, any>>({})

// Storage for exam5 specific data
const exam5Data = ref<any>(null)
const exam5UserEntries = ref<any[]>([])

export function useExamData() {
  const setExamData = (data: ExamData) => {
    examData.value = data
  }

  const getExamData = (): ExamData | null => {
    return examData.value
  }

  const clearExamData = () => {
    examData.value = null
    examCompleted.value = false
    examComponentData.value = {}
    exam5Data.value = null
    exam5UserEntries.value = []
  }

  const setExamCompleted = (completed: boolean) => {
    examCompleted.value = completed
  }

  const isExamCompleted = (): boolean => {
    return examCompleted.value
  }

  const hasExamData = (): boolean => {
    return examData.value !== null
  }

  const isValidSession = (): boolean => {
    return hasExamData()
  }

  const wasPageReloaded = (): boolean => {
    // リロード検知機能を無効化（問題の原因となっているため）
    return false
  }

  // Exam5 specific methods
  const setExam5Data = (data: any) => {
    exam5Data.value = data
  }

  const getExam5Data = () => {
    return exam5Data.value
  }

  const setExam5UserEntries = (entries: any[]) => {
    exam5UserEntries.value = entries
  }

  const getExam5UserEntries = () => {
    return exam5UserEntries.value
  }

  // Generic component data methods
  const setComponentData = (componentName: string, data: any) => {
    examComponentData.value[componentName] = data
  }

  const getComponentData = (componentName: string) => {
    return examComponentData.value[componentName]
  }

  return {
    setExamData,
    getExamData,
    clearExamData,
    hasExamData,
    isValidSession,
    wasPageReloaded,
    setExamCompleted,
    isExamCompleted,
    setExam5Data,
    getExam5Data,
    setExam5UserEntries,
    getExam5UserEntries,
    setComponentData,
    getComponentData
  }
}